import React from "react";
import Pagination from "@atlaskit/pagination";

import { useTablePaginationContext } from "./context";
import { Box } from "../../UI/Box";

export const TablePagination = () => {
  const { pages, setPage } = useTablePaginationContext();

  const handlePageChange = (
    _: React.SyntheticEvent<Element, Event>,
    page: number
  ) => {
    setPage(page);
  };

  return (
    <Box display="flex" justifyContent="center" width="100%" mt={2} mb={4}>
      <Pagination pages={pages} onChange={handlePageChange} />
    </Box>
  );
};
